export default __webpack_public_path__ + "static/media/FubraumschonerTOPTEX.f0829323.jpg";